import { render, staticRenderFns } from "./SimCardProfile.vue?vue&type=template&id=a0d7abe4&"
import script from "./SimCardProfile.vue?vue&type=script&lang=js&"
export * from "./SimCardProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports